var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCapponeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95996 34.14C6.38996 25.91 12.67 18.39 20.82 15.14C34.72 9.59001 38.28 21.32 38.36 22.69C40.89 23.79 44.26 25.73 45.04 28.42C39.61 28.42 36.69 29.61 34.54 31.28C32.24 33.07 28.81 39.62 28.81 47.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3599 22.6899C37.7599 22.6899 36.78 23.1999 36.45 23.6399",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.22 19.82C47.9 15.05 43.13 4.54996 38.36 12.19C38.36 3.59996 31.68 -3.08004 31.68 9.32996C28.82 3.59996 23.62 2.64996 22.14 2.64996C19.53 2.64996 22.54 8.84996 22.14 12.19",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3599 33.1799C38.8699 34.8899 44.8799 39.6299 41.2199 41.7699C38.4399 43.3999 32.6299 42.7199 32.6299 42.7199",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCapponeWhite);
export default __webpack_public_path__ + "static/media/ic_cappone_white.ea02658833a85ed28a640b7733373db4.svg";
export { ForwardRef as ReactComponent };